﻿const toRad = (num) => {
  return num * Math.PI / 180;
};

const convertCoordinates = (format, coordinates) => {
  switch (format) {
    case '[lat,lon]':
      return { latitude: coordinates[0], longitude: coordinates[1] };
    case '[lon,lat]':
      return { latitude: coordinates[1], longitude: coordinates[0] };
    case '{lon,lat}':
      return { latitude: coordinates.lat, longitude: coordinates.lon };
    case '{lat,lng}':
      return { latitude: coordinates.lat, longitude: coordinates.lng };
    case 'geojson':
      return { latitude: coordinates.geometry.coordinates[1], longitude: coordinates.geometry.coordinates[0] };
    default:
      return coordinates;
  }
};

export const calculateDistance = (startCoordinates, endCoordinates, options) => {
  options = options || {};

  const RADII = {
    km: 6371,
    mile: 3960,
    meter: 6371000,
    nmi: 3440
  };

  var R = options.unit in RADII ? RADII[options.unit] : RADII.meter;
  var start = convertCoordinates(options.format, startCoordinates);
  var end = convertCoordinates(options.format, endCoordinates);

  var dLat = toRad(end.latitude - start.latitude);
  var dLon = toRad(end.longitude - start.longitude);
  var lat1 = toRad(start.latitude);
  var lat2 = toRad(end.latitude);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  if (options.threshold)
    return options.threshold > R * c;

  return R * c;
}

export const getRandomCoordinates = (latMin, latMax, lngMin, lngMax) => {
  const fixed = 3;
  const lat = (Math.random() * (latMin - latMax) + latMax).toFixed(fixed) * 1;
  const lng = (Math.random() * (lngMin - lngMax) + lngMax).toFixed(fixed) * 1;
  
  return { lat, lng };
}

export const generateGuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export const removeDuplicatedFacilities = (facilities) => {
  return Array.from(new Set(facilities.map(a => a.uid)))
    .map(uid => facilities.find(a => a.uid === uid))
    .sort((a, b) => a.address.distance - b.address.distance);
}

export const sortFacilitiesBasedOnDistance = (facilities) => {
  return facilities.sort((a, b) => a.address.distance - b.address.distance);
}

export const groupArrayBy = (xs, key) => {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export const groupBy = (items, key) => items.reduce(
  (result, item) => ({
    ...result,
    [item[key]]: [
      ...(result[item[key]] || []),
      item,
    ],
  }), 
  [],
);